module.exports = __webpack_public_path__ + "19f4e892e0a7ab441996fa60607fae80.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/times.ttf
// module id = 1051
// module chunks = 0